import React, { useEffect, useState } from 'react'


import './index.css'

import Particle from '../Particle'

const cardData = [
  {
    id: 1,
    imageUrl: '../../assets/images/ietkart.jpg',
    title: 'IET-KART',
    content: 'Ietkart is an online reselling platform specifically designed for college students to buy and sell items within their campus community. Leveraging the power of React and Spring Boot, ietkart provides a seamless and user-friendly experience for students to connect, trade, and discover a variety of college-related items.',
  },
  {
    id: 2,
    imageUrl: '../../assets/images/emart.png',
    title: 'E-MART',
    content: ' ',
  },
  {
    id: 3,
    imageUrl: '../../assets/images/weather.png',
    title: 'SkyCast',
    content: '',
  },
  {
    id: 4,
    imageUrl: '../../assets/images/vcall.png',
    title: 'CallHub',
    content: '',
  },

  // Add more card data with different image URLs
];

const Portfolio = () => {

  return (
    <>
      <Particle/>
      <div className='container'>
        <div className='card '>
          <div className='box card1'>
            <div className='content'>
             
              <h2>01</h2>
              <h3>IET-KART</h3>
              <p>
              Ietkart is an online reselling platform specifically designed for
              college students to buy and sell items within their campus
              community. Leveraging the power of <strong>React</strong> and Spring Boot, ietkart
              provides a seamless and user-friendly experience for students to
              connect, trade, and discover a variety of college-related items.
            </p>
              <a href='https://github.com/dhakad17/IET-KART'>Github</a>
            </div>

          </div>
        </div>
        <div className='card '>
          <div className='box card2'>
            <div className='content'>
              <h2>02</h2>
              <h3>Card Two</h3>
              <p>The Supermarket Product Management System is a comprehensive software solution developed using Java Swing and MySQL. This system aims to streamline and optimize the management of products in a supermarket environment</p>
              <a href='https://github.com/dhakad17/EMART-java-swing'>Github</a>
            </div>

          </div>
        </div>
        <div className='card '>
          <div className='box card3' >
            <div className='content'>
              <h2>03</h2>
              <h3>SkyCast</h3>
              <p>SkyCast is a dynamic and user-friendly weather application built using HTML, CSS, and JavaScript, empowered by web APIs to provide real-time weather data. With WeatherUp, you can effortlessly access up-to-the-minute weather information to plan your day effectively.</p>
              <a href='https://github.com/dhakad17/weatherAPP'>Github</a>
            </div>

          </div>
        </div>
        <div className='card '>
          <div className='box card4'>
            <div className='content'>
              <h2>04</h2>
              <h3>CallHub</h3>
              <p>CallHub is a cutting-edge peer-to-peer video calling application developed using React Native and powered by the Voximplant SDK. It enables seamless and secure video communication between users, connecting them regardless of geographical distances.</p>
              <a href='https://github.com/dhakad17/videocall-React-Native'>Github</a>
            </div>

          </div>
        </div>


         {/* {cardData.map((card) => (
        <div className="card" >
          <div className="box" key={card.id} style={{ backgroundImage: `url(${card.imageUrl})` }}>
            <div className="content">
              <h3>{card.title}</h3>
              <p>{card.content}</p>
            </div>
          </div>
        </div>
      ))} */}


      </div>

    </>
  )
}

export default Portfolio
